(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[362],{

/***/ "Q11S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CallMeBack", function() { return CallMeBack; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var CallMeBack = function CallMeBack(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.807 17.074C7.614 16.879 7.358 16.772 7.084 16.772H5.813C5.391 16.772 5.046 16.426 5.046 16.002V7.327C5.046 6.901 5.391 6.555 5.813 6.555H16.881C17.304 6.555 17.649 6.901 17.649 7.327V16.002C17.649 16.426 17.304 16.772 16.881 16.772H10.495C10.229 16.772 9.977 16.874 9.785 17.058L8.106 18.682V17.801C8.106 17.526 8 17.267 7.807 17.074V17.074ZM24.956 19.376C24.956 19.801 24.611 20.147 24.189 20.147H22.916C22.644 20.147 22.387 20.254 22.194 20.448C22.004 20.64 21.894 20.905 21.894 21.176V22.056L20.052 20.276L13.119 20.147C12.696 20.147 12.351 19.801 12.351 19.376V18.828H16.881C18.432 18.828 19.694 17.56 19.694 16.002V9.93H24.189C24.611 9.93 24.956 10.276 24.956 10.702V19.376ZM24.188 7.874H19.694V7.327C19.694 5.768 18.432 4.5 16.881 4.5H5.813C4.262 4.5 3 5.768 3 7.327V16.002C3 17.56 4.262 18.828 5.813 18.828H6.06L6.055 21.098C6.055 21.666 6.515 22.126 7.081 22.126C7.346 22.126 7.598 22.025 7.79 21.84L10.307 19.408C10.324 20.951 11.579 22.202 13.119 22.202H19.094L22.212 25.214C22.404 25.399 22.656 25.5 22.924 25.5C23.193 25.5 23.445 25.396 23.633 25.205C23.834 25.002 23.945 24.721 23.943 24.414L23.941 22.202H24.188C25.738 22.202 27 20.934 27 19.376V10.702C27 9.143 25.738 7.874 24.188 7.874V7.874Z"
  }));
};

/***/ })

}]);